// extracted by mini-css-extract-plugin
export default {"imageContainer":"image_imageContainer__eEvEZ","image":"image_image__vx+el","fallback":"image_fallback__T5+BL"};